import {AxiosInstance} from "axios";
import {OperationErrorApiDto, OperationRetriggerStatusApiDto} from "./model/rest";
import WorkspaceContainer from "../components/v5/table/workspace/WorkspaceContainer";

/**
 * Operation Errors Api.
 */
export default class OperationErrorsApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch operation errors
	 * @returns {Promise}
	 */
	fetchCodatOperationErrors(page: number): Promise<{ items: OperationErrorApiDto[], totalItems: number }> {
		const url = `/api/web/accounting/failed_codat_operations`;
		const params = {params: {page: page - 1, size: WorkspaceContainer.PAGE_SIZE}};
		return this.axiosInstance.get(url, params).then(resp => resp.data);
	}

	/**
	 * Retrigger opration
	 * @param id
	 */
	retriggerCodatOperation(id: string): Promise<OperationRetriggerStatusApiDto> {
		const url = `/api/web/accounting/failed_codat_operations/${id}/retrigger`;
		return this.axiosInstance.put(url).then(resp => resp.data)
	}

	/**
	 * Fetch operation errors
	 * @returns {Promise}
	 */
	fetchXeroOperationErrors(page: number): Promise<{ items: OperationErrorApiDto[], totalItems: number }> {
		const url = `/api/web/accounting/failed_xero_operations`;
		const params = {params: {page: page - 1, size: WorkspaceContainer.PAGE_SIZE}};
		return this.axiosInstance.get(url, params).then(resp => resp.data);
	}

	/**
	 * Retrigger opration
	 * @param id
	 */
	retriggerXeroOperation(id: string): Promise<OperationRetriggerStatusApiDto> {
		const url = `/api/web/accounting/failed_xero_operations/${id}/retrigger`;
		return this.axiosInstance.put(url).then(resp => resp.data)
	}
}
